var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"my-0 px-0 py-0",attrs:{"fluid":""}},[_c('q-content-submenu',{ref:"contentMenu",attrs:{"nav-menu-id":_vm.navMenuId}}),_c('div',{class:_vm.stickybuffer ? 'q-sticky-buffer' : ''},[_c('v-container',{staticClass:"px-5 transparent site-width",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }